/* Code generated with AutoHTML Plugin for Figma */
import { Article, Category, ID } from "@project/shared-types";
import { useEffect, useMemo, useRef, useState } from "react";
import { BreadCrumbs } from "../../components/BreadCrumbs/BreadCrumbs";
import Dropdown from "../../components/Dropdown/Dropdown";
import { Text } from "../../components/texts/text";
import Title from "../../components/texts/title";
import { _sizeHeading, _sizeText } from "../../core/core";
import { GetArticlesAPI } from "../../entities/article/model/blog.api";
import { ArticleView } from "../../entities/article/ui/Article/Article";
import { CategoryView } from "../../entities/category/ui/Category/Category";
import { useEndOfScroll } from "../../hooks/useEndOfScroll";
import "./Blog.css";
export const Blog = ({ ...props }) => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [categoryes, setCategoryes] = useState<Category[]>([]);
  const [categoryId, setCategoryId] = useState<ID | null>(null);
  const category = useMemo(
    () => categoryes.find((c) => c.id === categoryId),
    [categoryes, categoryId]
  );
  const handleCategoryClick = (newId: ID) => {
    console.log(newId);
    const current = categoryes.find((c) => c.id === newId);
    if (!current) return;
    setCategoryId(current.id);
  };
  const getOption = () => {
    const options = [] as { label: string; id: string; key: string }[];
    categoryes.map((x) =>
      options.push({
        label: x.title,
        id: x.id,
        key: x.id,
      })
    );
    return options;
  };

  const [loading_ids, setLoadingIds] = useState<ID[]>([]);
  const isLoading = useRef(false);
  const isEndReached = useRef(false);

  useEndOfScroll({
    ref: null,
    callback: () => {
      if (isLoading.current || isEndReached.current) return;
      console.log("Достигли конца списка, загружаем ещё...");
      setLoadingIds((prev) => {
        return [...prev, ...articles.map((article) => article.id)];
      });
    },
    offset: 50, // срабатывает чуть заранее
  });

  const fetchArticles = async () => {
    try {
      if (isLoading.current) return;
      isLoading.current = true;
      const is_staff = false;
      const response = await GetArticlesAPI({
        is_client: true,
        is_staff: is_staff,
        is_hm: true,
        loading_ids: loading_ids,
      });
      setArticles((prev) => {
        return [
          ...prev,
          ...response.articles.filter(
            (article) => article.is_for_staff === true
          ),
        ];
      });
      if (response.categories.length > 0) {
        setCategoryes(response.categories);
      }
      // Если пришло меньше статей чем запрашивали, значит это последняя страница
      if (response.articles.length < 6) {
        isEndReached.current = true;
      }
    } catch (error) {
      console.error("Ошибка при получении карточек услуг:", error);
    } finally {
      isLoading.current = false;
    }
  };

  useEffect(() => {
    fetchArticles();
  }, [category, loading_ids]);
  const breadLinks = [
    { url: "/", name: "Главная" },
    { url: "/blog/", name: "Блог" },
  ];

  return (
    <div className="blog">
      <BreadCrumbs links={breadLinks}></BreadCrumbs>
      <Title type={_sizeHeading.h2} is_h1>
        Блог
      </Title>

      <div className="blog-body">
        {categoryes.length > 0 && (
          <div className="blog-category-uslugi">
            <Title type={_sizeHeading.h3}>Категории</Title>
            <svg
              className="blog-vector"
              width="232"
              height="228"
              viewBox="0 0 232 228"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M54.5261 64.2663C46.8441 75.2185 45.2367 89.4513 40.4612 101.815C37.2944 110.013 32.7853 117.554 29.7618 125.817C28.2853 129.853 25.7924 135.747 27.0112 140.803C27.8043 144.093 33.5118 141.501 34.0136 141.321C42.1237 138.406 49.2263 134.117 54.9365 128.955C60.9753 123.497 64.4393 116.745 68.6077 110.157C73.3263 102.698 79.4129 96.1379 85.1148 89.2939C85.665 88.6335 97.0892 75.3516 97.3003 75.5442C98.8609 76.9647 97.5113 83.3613 97.4673 83.6503C96.1157 92.5288 93.536 100.987 91.2928 109.528C86.9184 126.184 83.551 143.326 77.0615 159.1C76.5041 160.455 69.5666 171.088 77.415 168.821C84.817 166.683 90.6685 162.214 95.9486 158.077C103.951 151.806 110.808 144.775 116.62 136.965C123.446 127.794 128.013 116.689 137.453 109.22C138.502 108.39 142.258 104.035 143.788 107.706C146.444 114.078 146.401 120.944 146.556 126.864C146.885 139.421 146.351 152.017 144.77 164.043C143.357 174.785 138.548 183.962 134.99 193.807C134.767 194.426 133.854 196.112 134.417 195.705C137.716 193.32 141.015 190.902 144.099 188.344C155.043 179.269 163.182 168.135 172.928 158.19C175.442 155.625 213.48 105.053 216.952 103.343"
                stroke="#2C3135"
                strokeWidth="27"
                strokeLinecap="round"
              />
            </svg>
            <Dropdown
              mobile={true}
              options={getOption()}
              onSelect={handleCategoryClick}
            >
              <div className="fast-service-title">
                <Text size={_sizeText.m}>
                  {category ? category.title : "Все"}
                </Text>
              </div>
            </Dropdown>
            <div className="blog-items">
              {categoryes.map((category) => (
                <a
                  key={category.id}
                  onClick={() => handleCategoryClick(category.id)}
                  className={
                    category.id === category.id
                      ? `fast-services-item fast-services-active`
                      : `fast-services-item`
                  }
                >
                  <CategoryView id={category.id}>{category.title}</CategoryView>
                </a>
              ))}
            </div>
          </div>
        )}

        <div className="blog-articles">
          {articles.map((article) => (
            <ArticleView articleData={article}></ArticleView>
          ))}
        </div>
      </div>
    </div>
  );
};
